import {
  CHANGE_SELECTION_DATA,
  CHANGE_TABLE_FILTERS,
  CHANGE_TRAINING_RESULTS_MODAL_POSTPONED_DATE,
  CHANGE_TRAINING_RESULTS_MODAL_STATUS,
  CLEAR_TABLE_FILTERS,
  EMERGENCY_STOP_REQUEST_ASYNC,
  GET_CAMPAIGN_DATA_ASYNC,
  GET_REPORT_PARTICIPANTS_LIST_ASYNC,
  GET_REPORT_SUMMARY_ASYNC,
  RESEND_TRAINING_REQUEST_ASYNC,
  RESET_REPORT,
  RESET_SELECTION_DATA,
  SAVE_DRAFT_ASYNC,
  SAVE_MANUAL_TRAINING_RESULTS_ASYNC,
  SEGMENT_FILTER_CHANGE,
  SET_TABLE_FILTERS,
  SHARE_CSV_REPORT_ASYNC,
} from './constants'

const resendTraining = (id) => ({
  type: RESEND_TRAINING_REQUEST_ASYNC.INITIATE,
  payload: { id },
})
export const resendTrainingSuccess = () => ({
  type: RESEND_TRAINING_REQUEST_ASYNC.SUCCESS,
})
export const resendTrainingError = (error) => ({
  type: RESEND_TRAINING_REQUEST_ASYNC.ERROR,
  error,
})
const resendTrainingCancel = () => ({
  type: RESEND_TRAINING_REQUEST_ASYNC.CANCEL,
})

const emergencyStop = (id) => ({
  type: EMERGENCY_STOP_REQUEST_ASYNC.INITIATE,
  payload: { id },
})
export const emergencyStopSuccess = () => ({
  type: EMERGENCY_STOP_REQUEST_ASYNC.SUCCESS,
})
export const emergencyStopError = (error) => ({
  type: EMERGENCY_STOP_REQUEST_ASYNC.ERROR,
  error,
})
const emergencyStopCancel = () => ({
  type: EMERGENCY_STOP_REQUEST_ASYNC.CANCEL,
})

const getReportParticipantsList = (params) => ({
  type: GET_REPORT_PARTICIPANTS_LIST_ASYNC.INITIATE,
  payload: { params },
})
export const getReportParticipantsListSuccess = (data) => ({
  type: GET_REPORT_PARTICIPANTS_LIST_ASYNC.SUCCESS,
  payload: { data },
})
export const getReportParticipantsListError = (error) => ({
  type: GET_REPORT_PARTICIPANTS_LIST_ASYNC.ERROR,
  error,
})
const getReportParticipantsListCancel = () => ({
  type: GET_REPORT_PARTICIPANTS_LIST_ASYNC.CANCEL,
})

const getReportSummary = (reportId) => ({
  type: GET_REPORT_SUMMARY_ASYNC.INITIATE,
  payload: { reportId },
})
export const getReportSummarySuccess = (data) => ({
  type: GET_REPORT_SUMMARY_ASYNC.SUCCESS,
  payload: { data },
})
export const getReportSummaryError = (error) => ({
  type: GET_REPORT_SUMMARY_ASYNC.ERROR,
  error,
})
const getReportSummaryCancel = () => ({
  type: GET_REPORT_SUMMARY_ASYNC.CANCEL,
})

const saveDraft = (selection) => ({
  type: SAVE_DRAFT_ASYNC.INITIATE,
  payload: { selection },
})
export const saveDraftSuccess = (id) => ({
  type: SAVE_DRAFT_ASYNC.SUCCESS,
  payload: { id },
})
export const saveDraftError = (error) => ({
  type: SAVE_DRAFT_ASYNC.ERROR,
  payload: { error },
})
const saveDraftCancel = () => ({
  type: SAVE_DRAFT_ASYNC.CANCEL,
})

const getCampaignData = (id) => ({
  type: GET_CAMPAIGN_DATA_ASYNC.INITIATE,
  payload: { id },
})
export const getCampaignDataSuccess = (data) => ({
  type: GET_CAMPAIGN_DATA_ASYNC.SUCCESS,
  payload: { data },
})
export const getCampaignDataError = (error) => ({
  type: GET_CAMPAIGN_DATA_ASYNC.ERROR,
  payload: { error },
})
const getCampaignDataCancel = () => ({
  type: GET_CAMPAIGN_DATA_ASYNC.CANCEL,
})

const saveManualTrainingResults = (id) => ({
  type: SAVE_MANUAL_TRAINING_RESULTS_ASYNC.INITIATE,
  payload: { id },
})
export const saveManualTrainingResultsSuccess = (data) => ({
  type: SAVE_MANUAL_TRAINING_RESULTS_ASYNC.SUCCESS,
  payload: { data },
})
export const saveManualTrainingResultsError = (error) => ({
  type: SAVE_MANUAL_TRAINING_RESULTS_ASYNC.ERROR,
  payload: { error },
})
const saveManualTrainingResultsCancel = () => ({
  type: SAVE_MANUAL_TRAINING_RESULTS_ASYNC.CANCEL,
})

const shareCsvReport = (id) => ({
  type: SHARE_CSV_REPORT_ASYNC.INITIATE,
  payload: { id },
})
export const shareCsvReportSuccess = () => ({
  type: SHARE_CSV_REPORT_ASYNC.SUCCESS,
})
export const shareCsvReportError = (error) => ({
  type: SHARE_CSV_REPORT_ASYNC.ERROR,
  payload: { error },
})
const shareCsvReportCancel = () => ({
  type: SHARE_CSV_REPORT_ASYNC.CANCEL,
})
const segmentFilterChange = (val, campaignId) => ({
  type: SEGMENT_FILTER_CHANGE,
  payload: { val, campaignId },
})
const changeTableFilters = (field, value) => ({
  type: CHANGE_TABLE_FILTERS,
  payload: { field, value },
})
const clearTableFilters = () => ({ type: CLEAR_TABLE_FILTERS })
const resetReport = () => ({ type: RESET_REPORT })
const changeSelectionData = (field, value) => ({
  type: CHANGE_SELECTION_DATA,
  payload: { field, value },
})
const setTableFilters = (data) => ({
  type: SET_TABLE_FILTERS,
  payload: { data },
})
const resetSelectionData = () => ({ type: RESET_SELECTION_DATA })
const changeTrainingResultsModalStatus = (value) => ({
  type: CHANGE_TRAINING_RESULTS_MODAL_STATUS,
  payload: { value },
})

const changeTrainingResultsModalPostponedDate = (value) => ({
  type: CHANGE_TRAINING_RESULTS_MODAL_POSTPONED_DATE,
  payload: { value },
})

export default {
  // to props
  resendTraining,
  resendTrainingCancel,
  emergencyStop,
  emergencyStopCancel,
  segmentFilterChange,
  getReportParticipantsList,
  getReportParticipantsListCancel,
  saveDraft,
  saveDraftCancel,
  getReportSummary,
  getReportSummaryCancel,
  changeTableFilters,
  clearTableFilters,
  getCampaignData,
  getCampaignDataCancel,
  resetReport,
  changeSelectionData,
  resetSelectionData,
  shareCsvReport,
  shareCsvReportCancel,
  changeTrainingResultsModalStatus,
  changeTrainingResultsModalPostponedDate,
  saveManualTrainingResults,
  saveManualTrainingResultsCancel,
  setTableFilters,
}
